import { toast } from "react-toastify";
import ImageIcon from "@mui/icons-material/Image";
import { styles } from "../../pages/MyTracks/styles";
import { UploadArtWorkProps } from "./types";
import { BORDER_COLOR, TEXT_COLOR } from "../../theme";

export const UploadArtWork: React.FC<UploadArtWorkProps> = ({
  previewUrl,
  handleBlur,
  handleDragOver,
  setFieldValue,
  handleFile,
  isSubmitting,
}) => {
  const handleFileUpload = (file: File) => {
    const sanitizedFileName = encodeURIComponent(file.name);
    const sanitizedFile = new File([file], sanitizedFileName, {
      type: file.type,
      lastModified: file.lastModified,
    });
    if (file.type.split("/")[0] !== "image") {
      toast.info("Upload an image file");
      return;
    }
    handleFile(sanitizedFile);
    setFieldValue("coverArtUpload", sanitizedFile);
  };

  return (
    <>
      <label htmlFor="artwork" className="uploadLabel">
        Upload Artwork <span className="optional-input">(optional)</span>
      </label>
      <label
        htmlFor="cover-art-upload"
        className="image-upload cover-upload"
        style={{
          borderStyle: previewUrl ? "none" : "dashed",
          borderWidth: "2px",
          borderColor: BORDER_COLOR,
          width: "65%",
        }}
        onBlur={handleBlur}
        onDragOver={handleDragOver}
        onDrop={(event: React.DragEvent<HTMLLabelElement>) => {
          event.preventDefault();
          event.stopPropagation();

          const droppedFile = event.dataTransfer.files[0];
          if (droppedFile) {
            handleFileUpload(droppedFile);
          }
        }}
        onClick={handleBlur}
      >
        <input
          style={{ color: "white", backgroundColor: "white" }}
          type="file"
          name="coverArtUpload"
          id="cover-art-upload"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const selectedFile = event.currentTarget.files?.[0];
            if (selectedFile) {
              handleFileUpload(selectedFile);
              event.currentTarget.value = "";
            }
          }}
          accept="image/*"
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
        {!previewUrl && (
          <>
            <ImageIcon
              sx={{ ...styles.modalImagePlaceholder, color: TEXT_COLOR }}
            />
            <img style={{ color: TEXT_COLOR }} alt="" className="edit" />
          </>
        )}

        {previewUrl && (
          <img
            src={previewUrl}
            alt="cover"
            height={"100%"}
            width={"100%"}
            color={TEXT_COLOR}
          />
        )}
      </label>
      <p className="input-description">
        Image type supported: JPG or JPEG. Max size 10 MB
      </p>
      <p className="input-description" style={{ marginTop: -25 }}>
        Square at least 3000x3000 pixels, not blurry or pixelated.
      </p>
    </>
  );
};
